import React from 'react'
import { useTranslation } from 'react-i18next'
import { SearchSvg } from '../other/svg/Index'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducer } from 'src/redux/rootReducer'
import { SET_FILTERS } from 'dealer-reducers'
import track from 'src/helpers/track'

const UniversalSearch = (): JSX.Element => {
  const { t } = useTranslation()
  const currentTab = useSelector((state: RootReducer) => state.offersListReducer.tab)
  const filters = useSelector((state: RootReducer) => state.tableToolsReducer.filters[currentTab])
  const dispatch = useDispatch()
  return (
    <div
      className="xl:w-48 h-8 px-2 bg-backgrounds-bg-field-component rounded-md flex justify-start items-center gap-2 overflow-hidden w-[120px]"
      style={{
        boxShadow: '0px 0px 0px 1px rgba(0,0,0,0.08), 0px 1px 2px 0px rgba(0,0,0,0.12)'
      }}>
      <div className="w-3.5 h-3.5 relative overflow-hidden">
        <SearchSvg />
      </div>
      <input
        // since all text filters are treated the same on backend side we can set any one of them
        onChange={(e) => {
          dispatch(SET_FILTERS({ ...filters, hash_id: e.target.value, tab: currentTab }))
          track('dealer_type_search_input')
        }}
        value={filters.hash_id}
        className="flex-1 justify-start text-foregrounds-fg-muted text-xs font-normal font-Montserrat leading-tight h-full w-full outline-none"
        placeholder={t('bottom_menu.search')}
      />
    </div>
  )
}

export default UniversalSearch
